$(function (){
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    function scrollToI ($this, pc_pixel, sp_pixel){
        var $root = $('html, body');
            $root.animate({
                scrollTop: $(window).width() >= 694 ?  $this.offset().top - pc_pixel : $this.offset().top - sp_pixel
            }, 300, 'swing');
    }
    $('.topics__lists li').click(function(){
        $('.topics__lists li').removeClass('is-active');           
        $(this).addClass('is-active');
    });

    $(window).on('load', function(){
        var alpha = window.location.hash;
        if (alpha) {
            scrollToI($(`div[id="${alpha.replace("#","")}"]`), 80, 110);
        }
    })
    $('.list__alphabet > li > a').click(function (e) {
        e.preventDefault();
        var bannerHeight = ($('.swiper_header_box:visible').outerHeight() || 0);
        var height =  $(window).width() >= 694 ? (90 + bannerHeight) : (110 + bannerHeight);
        window.scrollTo(
            {
                top: $(`div[id="${$(this).attr('href').replace('#', '')}"]`).offset().top - height,
                behavior: 'smooth'
            }
        )
    });
})

